var path = '/RockArtPanel'

function get (http, id) {
    return http.get(path + `/Get?id=${id}&getComponents=true`)
}
function put (http, rockArtPanelDto) {
    return http.put(path + '?saveComponents=true', rockArtPanelDto)
}
function search (http, searchDto) {
    return http.post(path + '/Search?getComponents=true', searchDto)
}

function getPanelAgeList () {
    return [
        {panelAgeId: 1, description: 'Modern'},
        {panelAgeId: 2, description: 'Historic'},
        {panelAgeId: 3, description: 'Protohistoric'},
        {panelAgeId: 4, description: 'Prehistoric'},
        {panelAgeId: 5, description: 'Unknown'}
    ]
}

function getPanelLocationList () {
    return [
        {panelLocationId: 1, description: 'Cliff'},
        {panelLocationId: 2, description: 'Flat Outcrop'},
        {panelLocationId: 3, description: 'Rockshelter '},
        {panelLocationId: 4, description: 'Boulder'},
        {panelLocationId: 5, description: 'Tree'},
        {panelLocationId: 6, description: 'Building/Structure'},
        {panelLocationId: 7, description: 'Other'}
    ]
}

function getCulturalAffiliationList () {
    return [
        {culturalAffiliationId: 1, description: 'Fremont'},
        {culturalAffiliationId: 2, description: 'Dinwoody'},
        {culturalAffiliationId: 3, description: 'General Great Plains'},
        {culturalAffiliationId: 4, description: 'Other Native American'},
        {culturalAffiliationId: 5, description: 'Euroamerican'},
        {culturalAffiliationId: 6, description: 'Unknown'}
    ]
}
function getPanelSymbolList () {
    return [
        {panelSymbolId: 1, isAnthropomorph: true, isZoomorph: false, description: 'V-Neck figure'},
        {panelSymbolId: 2, isAnthropomorph: true, isZoomorph: false, description: 'Shield bearing warrior'},
        {panelSymbolId: 3, isAnthropomorph: true, isZoomorph: false, description: 'Stick'},
        {panelSymbolId: 4, isAnthropomorph: true, isZoomorph: false, description: 'Square shoulder'},
        {panelSymbolId: 5, isAnthropomorph: true, isZoomorph: false, description: 'Oval/round-bodied'},
        {panelSymbolId: 6, isAnthropomorph: true, isZoomorph: false, description: 'Triangular/tapered'},
        {panelSymbolId: 7, isAnthropomorph: true, isZoomorph: false, description: 'Naturalistic'},
        {panelSymbolId: 8, isAnthropomorph: true, isZoomorph: false, description: 'Don’t know'},
        {panelSymbolId: 9, isAnthropomorph: true, isZoomorph: false, description: 'Other(describe'},
        {panelSymbolId: 10, isAnthropomorph: false, isZoomorph: true, description: 'Bison'},
        {panelSymbolId: 11, isAnthropomorph: false, isZoomorph: true, description: 'Bear'},
        {panelSymbolId: 12, isAnthropomorph: false, isZoomorph: true, description: 'Canid'},
        {panelSymbolId: 13, isAnthropomorph: false, isZoomorph: true, description: 'Horse'},
        {panelSymbolId: 14, isAnthropomorph: false, isZoomorph: true, description: 'Elk/deer'},
        {panelSymbolId: 15, isAnthropomorph: false, isZoomorph: true, description: 'Sheep'},
        {panelSymbolId: 16, isAnthropomorph: false, isZoomorph: true, description: 'Pronghorn'},
        {panelSymbolId: 17, isAnthropomorph: false, isZoomorph: true, description: 'Unknown artiodactyl'},
        {panelSymbolId: 18, isAnthropomorph: false, isZoomorph: true, description: 'Bird'},
        {panelSymbolId: 19, isAnthropomorph: false, isZoomorph: true, description: 'Reptile/Amphibian'},
        {panelSymbolId: 20, isAnthropomorph: false, isZoomorph: true, description: 'Don’t know'},
        {panelSymbolId: 21, isAnthropomorph: false, isZoomorph: true, description: 'Other (describe)'},
        {panelSymbolId: 22, isAnthropomorph: false, isZoomorph: false, description: 'Abstracts/Symbols'},
        {panelSymbolId: 23, isAnthropomorph: false, isZoomorph: false, description: 'Name/Initials/Dates'}
    ]
}

function getCompassBearingList () {
    return [
        {panelAspectId: 1, description: 'N'},
        {panelAspectId: 2, description: 'NW'},
        {panelAspectId: 3, description: 'NE'},
        {panelAspectId: 4, description: 'E'},
        {panelAspectId: 5, description: 'S'},
        {panelAspectId: 6, description: 'SE'},
        {panelAspectId: 7, description: 'SW'},
        {panelAspectId: 8, description: 'W'}
    ]
}

export default {
    get: get,
    put: put,
    search: search,
    getPanelAgeList: getPanelAgeList,
    getPanelLocationList: getPanelLocationList,
    getCulturalAffiliationList: getCulturalAffiliationList,
    getPanelSymbolList: getPanelSymbolList,
    getCompassBearingList: getCompassBearingList
}



// WEBPACK FOOTER //
// ./src/services/siteForm/rockArtService.js